import { Globe2, MapPinned, PhoneCall } from 'lucide-react'
import type { SiteCopy } from '../content'
import { trackConversion } from '../lib/analytics'
import SpotlightCard from './react-bits/SpotlightCard'
import { HeroBlock } from './blocks/HeroBlock'

export function Hero({ t }: { t: SiteCopy }) {
  const preview = <SpotlightCard className="hero-preview" spotlightColor="rgba(15, 101, 124, 0.2)">
    <div className="hero-preview-meta"><span>{t.hero.sceneMeta}</span><span>LIVE PREVIEW</span></div>
    <div className="hero-preview-route">
      <div className="hero-preview-node"><MapPinned aria-hidden="true" /><span>{t.hero.sceneSteps[0]}</span></div>
      <i aria-hidden="true" />
      <div className="hero-preview-node hero-preview-site"><Globe2 aria-hidden="true" /><span>{t.hero.sceneSteps[1]}</span></div>
      <i aria-hidden="true" />
      <div className="hero-preview-node"><PhoneCall aria-hidden="true" /><span>{t.hero.sceneSteps[2]}</span></div>
    </div>
    <div className="hero-preview-copy"><strong>{t.hero.sceneTitle}</strong><span>{t.hero.sceneCaption}</span></div>
  </SpotlightCard>

  return <HeroBlock copy={t.hero} preview={preview} onPrimaryClick={() => trackConversion('hero_cta_click')} />
}
